import { useState } from "react";
import { Alert, Button } from "./Form";
import { api, errorMessage } from "../lib/api";
import { t } from "../lib/i18n";

/** "Bayar dengan FPX / kad" — sends the buyer to the Stripe page; they come back to /beli or /kredit with ?bayar=1. */
export function GatewayPay({ reference, email }: { reference: string; email: string }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  async function go() {
    setBusy(true);
    setError(null);
    try {
      const r = await api<{ url: string }>(`/api/orders/${reference}/checkout`, { method: "POST", json: { email } });
      window.location.href = r.url;
    } catch (e) {
      setError(errorMessage(e));
      setBusy(false);
    }
  }
  return (
    <div className="space-y-2 rounded-card border-2 border-accent bg-accent-soft/40 p-4">
      <h2 className="font-semibold">{t("Bayar dengan FPX / kad")}</h2>
      <p className="text-sm text-muted">{t("Terus ke internet banking anda. Disahkan secara automatik — tak perlu hantar resit.")}</p>
      {error && <Alert kind="error">{error}</Alert>}
      <Button onClick={go} busy={busy} className="w-full">{t("Bayar sekarang (FPX / kad)")}</Button>
    </div>
  );
}
